import type { Point } from "../../shared/types"

// The visible pixel closest to the top-left corner (ties go to the higher one): most arrow tips.
export const autoDetectHotspot = ({ data, width, height }: ImageData): Point => {
  let best: (Point & { score: number }) | null = null
  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      if (data[(y * width + x) * 4 + 3] < 128) continue

      const score = x + y
      if (!best || score < best.score || (score === best.score && y < best.y))
        best = { x, y, score }
    }
  }
  return best ? { x: best.x, y: best.y } : { x: 0, y: 0 }
}
